import React, { useEffect, useState } from 'react'
import { Route, Routes, BrowserRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { toast, ToastContainer } from 'react-toastify'
import NavbarComponent from '../components/global/navbar'
import URL from '../constants/urls'
import usePathDetector from '../Hooks/pathChangeDetector'
import Main from '../pages/main/Main'
import ThankyouPage from '../pages/thankyouPage'
import { getPartnerDetails, getPartnerDetailsBySLug } from '../redux/actions/partnerAction'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../constants/globalConstants'
import PreviousHistory from '../pages/previousHistory/PreviousHistory'
import NotFound from '../components/global/NotFound'


function RoutesComponent(props) {
	const { dispatch, isFetching } = props
	const path = window.location.toString().split('/')[3]
	const [title, setTitle] = useState('')
	const isPathChanged = usePathDetector()
	const [partnerDetails, setPartnerDetails] = useState(EMPTY_OBJECT)
	const [faviconPath, setFaviconPath] = useState('')
	const [loading, setLoading] = useState(true)
	
	useEffect(() => {
		localStorage.removeItem('partnerData')
		if(path){
			setLoading(true)
			dispatch(getPartnerDetailsBySLug(path)).then((res) => {
				setLoading(false)
				localStorage.setItem('partnerData', JSON.stringify(res?.data))
				const partnerData = res?.data
				setPartnerDetails(res?.data)
				setTitle(res?.data?.company_name ? res?.data?.company_name : res?.data?.name ? res?.data?.name : 'Citation')
				setFaviconPath(res?.data?.brand_setting ? res?.data?.brand_setting?.logourl : res?.data?.partner_details?.brand_setting?.logourl)
				let color = partnerData?.brand_setting ? partnerData?.brand_setting?.color : partnerData?.partner_details?.brand_setting?.color
				let rgb = partnerData?.brand_setting ? JSON.parse(partnerData?.brand_setting?.rgb_color) : JSON.parse(partnerData?.partner_details?.brand_setting?.rgb_color)
				if (color) {
					document.documentElement.style.setProperty('--bs-primary', color)
					document.documentElement.style.setProperty('base-color', color)
					document.documentElement.style.setProperty('primary', color)
					document.documentElement.style.setProperty('textcolor', color)
					document.documentElement.style.setProperty('--bs-btn-bg', color)
					document.documentElement.style.setProperty('--bs-primary-rgb', `${rgb?.r},${rgb?.g},${rgb?.b}`)
					document.documentElement.style.setProperty('--bs-list-group-active-border-color', color)
					document.documentElement.style.setProperty('--bs-list-group-active-color', color)
					document.documentElement.style.setProperty('--bs-list-group-active-bg', color)
				}
			}).catch((err) => {
				setLoading(false)
				console.log(err)
			})
		}else{
			if(window.location.hostname.includes('breezeparking') || window.location.hostname.includes('pci')){
				window.location.pathname = '/pci'
			}
		}
		


	}, [EMPTY_ARRAY])

	useEffect(() => {
		const updateFavicon = () => {
			const favicon = document.querySelector('link[rel="icon"]')
			favicon.href = faviconPath
		}

		const updateTitle = () => {
			document.title = title
		}

		updateFavicon()
		updateTitle()
	}, [faviconPath, title])

	useEffect(() => {

		const partnerData = getPartnerDetails()
		const color = partnerData?.brand_setting?.color
		if (partnerData?.brand_setting && partnerData?.brand_setting?.color) {
			document.documentElement.style.setProperty('--bs-primary', color)
			document.documentElement.style.setProperty('base-color', color)
			document.documentElement.style.setProperty('primary', color)
			document.documentElement.style.setProperty('textcolor', color)
			document.documentElement.style.setProperty('--bs-btn-bg', color)
			document.documentElement.style.setProperty('--bs-primary-rgb', '34, 32, 93')
			document.documentElement.style.setProperty('--bs-list-group-active-border-color', color)
			document.documentElement.style.setProperty('--bs-list-group-active-color', color)
			document.documentElement.style.setProperty('--bs-list-group-active-bg', color)
		}
	}, [EMPTY_ARRAY, isPathChanged])

	const notify = (type, message) => {
		if (type === 'error') {
			toast.error(message, {
				position: toast.POSITION.TOP_RIGHT
			})
			toast.clearWaitingQueue()
		} else if (type === 'success') {
			toast.success(message, {
				position: toast.POSITION.TOP_RIGHT
			})
			toast.clearWaitingQueue()
		}
	}

	return (
		<BrowserRouter forceRefresh className="mt-3">
			{isFetching || loading ? null : <NavbarComponent partnerDetails={partnerDetails} notify={notify} />}
			{isFetching || loading ? null : 
				partnerDetails?.email ? <Routes>
				<Route
					path={URL.HOME}
					element={<Main notify={notify} partnerDetails={partnerDetails} />}
				/>
				<Route
					path={URL.HOME2}
					element={<Main notify={notify} partnerDetails={partnerDetails} />}
				/>
				<Route
					path={URL.HOME3}
					element={<Main notify={notify} partnerDetails={partnerDetails} />}
				/>
				<Route
					path={URL.PAYMENT_RESPONSE2}
					element={<ThankyouPage notify={notify} partnerDetails={partnerDetails} />}
				/>
				<Route
					path={URL.PAYMENT_FAILED2}
					element={<ThankyouPage notify={notify} partnerDetails={partnerDetails} />}
				/>
				{/* for the preview history of citation and warning  */}
				<Route
					path={URL.PREVIOUS_HISTORY_CITAYION}
					element={<PreviousHistory notify={notify} partnerDetails={partnerDetails} />}
				/>
				{/* end  */}
				<Route
					path="*"
					element={
						<Main notify={notify} partnerDetails={partnerDetails} />
					} />
			</Routes> : <Routes>
					<Route
						path="*"
						element={
							<NotFound notify={notify} partnerDetails={partnerDetails} errorMessage={'Partner Not Found!'} />
						} 
					/>
				</Routes>}
			<ToastContainer limit={1} />
		</BrowserRouter>
	)
}
RoutesComponent.propTypes = {
	dispatch: PropTypes.func,
	isFetching: PropTypes.bool,
}

RoutesComponent.defaulProps = {
	dispatch: noop,
	isFetching: false

}

function mapStateToProps({ PartnerReducer }) {
	return {

		isFetching: PartnerReducer?.isFetching,
	}
}
export default connect(mapStateToProps)(RoutesComponent)

